import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { ACCOUNTS_API_CONFIG, INVOICES_API_CONFIG } from '@core/api/providers/providers.config';
import { VEHICLES_API_PROVIDER } from '@features/vehicles/infrastructure/providers/vehicles.provider';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { APP_REDUCERS } from '@store/app.state';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { provideApi as provideAccountsApi } from './core/api/generated/accounts/v1/provide-api';
import { provideApi as provideInvoicesApi } from './core/api/generated/invoices/v1/provide-api';
import { TOLLING_API_PROVIDER } from './features/activity/infraestructure/providers/tolling.provider';
import { ADDRESS_BOOK_API_PROVIDER } from './features/address-book/infrastructure/providers/address-book.provider';
import { APIM_AUTHENTICATION_API_PROVIDER } from './features/authentication/infrastructure/providers/apim-authentication.providers';
import { AUTHENTICATION_API_PROVIDER } from './features/authentication/infrastructure/providers/b2c-authentication.providers';
import { PAYMENT_API_PROVIDER } from './features/payments/infraestructure/providers/payment.provider';
import { REGISTRATION_API_PROVIDER } from './features/registration/infrastructure/providers/b2c-registration.provider';
import { SETTINGS_API_PROVIDER } from './features/settings/infrastructure/providers/settings.provider';
import { USER_SETTINGS_API_PROVIDER } from './features/user-settings/infrastructure/providers/user-settings.provider';
import { PAYMENTS_API_PROVIDER } from './features/wallet/infrastructure/providers/payments.provider';
import { authInterceptor } from './infrastructure/interceptors/auth.interceptor';
import { mockRoutingInterceptor } from './infrastructure/interceptors/mock-routing.interceptor';
import { TranslationsModule } from './infrastructure/translations/translations.module';
import { NextpassPartnersPreset } from './primeng-theme';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes, withComponentInputBinding()),
        provideHttpClient(withInterceptors([mockRoutingInterceptor, authInterceptor])),
        importProvidersFrom(TranslationsModule),
        REGISTRATION_API_PROVIDER,
        AUTHENTICATION_API_PROVIDER,
        APIM_AUTHENTICATION_API_PROVIDER,
        provideAccountsApi(ACCOUNTS_API_CONFIG),
        provideInvoicesApi(INVOICES_API_CONFIG),
        VEHICLES_API_PROVIDER,
        PAYMENT_API_PROVIDER,
        ADDRESS_BOOK_API_PROVIDER,
        TOLLING_API_PROVIDER,
        PAYMENTS_API_PROVIDER,
        SETTINGS_API_PROVIDER,
        USER_SETTINGS_API_PROVIDER,
        provideStore(APP_REDUCERS, {
            runtimeChecks: {
                // strictStateImmutability and strictActionImmutability are enabled by default
                strictStateSerializability: false,
                strictActionSerializability: false,
                strictActionWithinNgZone: true,
                strictActionTypeUniqueness: true,
                // if you want to change complexe objects and that we have. We need to disable these settings
                // change strictStateImmutability, strictActionImmutability
                strictStateImmutability: false,
                strictActionImmutability: false,
            },
        }),
        provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: NextpassPartnersPreset, options: { darkModeSelector: 'none' } } }),
    ],
};
